import { render, staticRenderFns } from "./cancelStakeForMining.vue?vue&type=template&id=eac1f138&"
import script from "./cancelStakeForMining.vue?vue&type=script&lang=js&"
export * from "./cancelStakeForMining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eac1f138')) {
      api.createRecord('eac1f138', component.options)
    } else {
      api.reload('eac1f138', component.options)
    }
    module.hot.accept("./cancelStakeForMining.vue?vue&type=template&id=eac1f138&", function () {
      api.rerender('eac1f138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/staking/cancelStakeForMining.vue"
export default component.exports